import { Parser } from "@siteimprove/alfa-parser";
import { Function, Token, } from "../../syntax/index.js";
import { Keyword } from "../textual/keyword.js";
import { Position } from "../position/index.js";
import { Value } from "../value.js";
import { BasicShape } from "./basic-shape.js";
import { Radius } from "./radius.js";
const { map, option, pair, right } = Parser;
/**
 * {@link https://drafts.csswg.org/css-shapes/#funcdef-circle}
 *
 * @public
 */
export class Circle extends BasicShape {
    static of(radius, center) {
        return new Circle(radius, center);
    }
    _radius;
    _center;
    constructor(radius, center) {
        super("circle", Value.hasCalculation(radius, center));
        this._radius = radius;
        this._center = center;
    }
    get radius() {
        return this._radius;
    }
    get center() {
        return this._center;
    }
    resolve(resolver) {
        return new Circle(this._radius.resolve(resolver), this._center.resolve(resolver));
    }
    partiallyResolve(resolver) {
        return new Circle(this._radius.partiallyResolve(resolver), this._center.partiallyResolve(resolver));
    }
    equals(value) {
        return (value instanceof Circle &&
            value._radius.equals(this._radius) &&
            value._center.equals(this._center));
    }
    hash(hash) {
        hash.writeHashable(this._radius).writeHashable(this._center);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            radius: this._radius.toJSON(),
            center: this._center.toJSON(),
        };
    }
    toString() {
        return `circle(${this._radius.toString()} at ${this._center.toString()})`;
    }
}
/**
 * @public
 */
(function (Circle) {
    function isCircle(value) {
        return value instanceof Circle;
    }
    Circle.isCircle = isCircle;
    Circle.parse = map(Function.parse("circle", pair(option(Radius.parse), option(right(option(Token.parseWhitespace), right(Keyword.parse("at"), right(Token.parseWhitespace, Position.parse())))))), ([_, [radius, center]]) => Circle.of(radius.getOr(Radius.of(Keyword.of("closest-side"))), center.getOr(Position.of(Keyword.of("center"), Keyword.of("center")))));
})(Circle || (Circle = {}));
//# sourceMappingURL=circle.js.map